import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from  '@angular/forms';
import { Router } from  '@angular/router';
import { AuthService } from  '../../../auth.service';
import { HttpService } from '../../../http.service';

import { SocialAuthService } from "angularx-social-login";
import { FacebookLoginProvider, GoogleLoginProvider } from "angularx-social-login";

declare var $: any;


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
	loginForm: FormGroup;
	forgotForm: FormGroup;
	isSubmitted  =  false;
	isSubmittedForgot  =  false;
	loginErrorMessage : String='';
	loginSpin:Number=0;
	loginSpinFacebook:Number=0;
	loginSpinGoogle:Number=0;
	forGotPasswordSpin:Number=0;
	forGotPasswordMessageApi : String='';
	
	constructor(
		private authServicesocial: SocialAuthService,
		private _http: HttpService,
		private authService: AuthService, 
		private formBuilder: FormBuilder,
		public router: Router
	){}
	
	ngOnInit() {
		
		setTimeout(function() {
			$('.modal-backdrop').remove();
			$('body').removeClass('cart-open');
			$('html').css('overflow','auto');
		}, 500);
		
		this.loginForm  =  this.formBuilder.group({
            email: ['', [Validators.required]],
			password: ['', Validators.required]
		});
		
		this.forgotForm  =  this.formBuilder.group({
			//forgotemail: ['', [Validators.required, Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]]
			forgotemail: ['', [Validators.required]]
		});
		
		this.authServicesocial.authState.subscribe((user : any) => {
			var isLogin=localStorage.getItem('isLogin');
			if(isLogin!='1' && user!=null){
				this.loginWithSocialMedia(user);
			}
			
		});
	
	}
	
	signInWithGoogle(): void {
		this.authServicesocial.signIn(GoogleLoginProvider.PROVIDER_ID);
	}
	
	signInWithFacebook(): void {
		this.authServicesocial.signIn(FacebookLoginProvider.PROVIDER_ID);
	}
	get formControls() { return this.loginForm.controls; }
	get formControlsforgot() { return this.forgotForm.controls; }
	
	//Login With Socical Media
	loginWithSocialMedia (socailMediaUser) {
		var loginQueryParms="";
		if(socailMediaUser.email===undefined || socailMediaUser.email==='') {
			alert('No Email is linked with your account');
			return false;
		}
		const loginData = new FormData();
		
		if(socailMediaUser.provider==='GOOGLE'){
			this.loginSpinGoogle=1;
			loginData.append("email", socailMediaUser.email);
			loginData.append("fullname", socailMediaUser.name);
			loginData.append("res_id", '49');
			loginData.append("login_type", 'Google');
			loginData.append("referral_code", 'Google');
			loginData.append("os", 'website');
			loginData.append("phone_no", '');
			

		} else if(socailMediaUser.provider==='FACEBOOK'){
			this.loginSpinFacebook=1;
			
			loginData.append("email", socailMediaUser.email);
			loginData.append("image", socailMediaUser.photoUrl);
			loginData.append("fullname", socailMediaUser.name);
			loginData.append("res_id", '49');
			loginData.append("login_type", 'Facebook');
			loginData.append("referral_code", 'Facebook');
			loginData.append("os", 'website');
			loginData.append("phone_no", '');

		}
		this._http.postRequest('userlogin.php?', loginData).subscribe(data => {
			this.loginSpinGoogle=0;
			if (data[0].status==='Success') {
				localStorage.setItem('isLogin' ,'1');
				localStorage.setItem('jwt_token' ,data[0].user_detail.auth_token);
				localStorage.setItem('user_detail' ,JSON.stringify(data[0].user_detail));
				this.router.navigateByUrl('/'); 
			} else {
				this.loginErrorMessage = "Invalid Credentials. Please Try Again ...";
			}
		});
		
	}
	
	login(){
		this.loginErrorMessage = "";
		if (!this.loginForm.value.email.includes('@')) {
			this.loginErrorMessage = "Invalid Email Address";
			return ;
		}
		
		this.isSubmitted = true;
		if(this.loginForm.invalid){
		  return;
		}
		
		const loginData = new FormData();
		loginData.append("email", this.loginForm.value.email);
		loginData.append("res_id", '49');
		loginData.append("password", this.loginForm.value.password);
		loginData.append("os", 'website');


		this.loginSpin=1;
		this._http.postRequest('userlogin.php',loginData).subscribe(data => {
			this.loginSpin=0;
			if (data[0].status==='Success') {
				localStorage.setItem('isLogin' ,'1');
				localStorage.setItem('jwt_token' ,data[0].user_detail.auth_token);
				localStorage.setItem('user_detail' ,JSON.stringify(data[0].user_detail));
				this.router.navigateByUrl('/');
			} else {
				if (data[0]['email_exist']) {
					this.loginErrorMessage = "Invalid password. Your account already has already been registered . You can reset your password by going to forgot password after entering your email.";
				} else {
					this.loginErrorMessage = "Invalid Credentials. Please Try Again ...";

				}
				
			}
		});
		/*this.authService.login();
		this.router.navigateByUrl('/admin'); */
	}
	
	loginGuestProccess () {
		localStorage.setItem('isLogin' ,'1');
		//localStorage.setItem('jwt_token' ,data[0].user_detail.auth_token);
		var data = {
			"id": "1",
			"fullname": "Guest",
			"email": "guest@gmail.com",
			"phone_no": "3222222222",
			"referal_code": "q2e",
			"image": "",
			"created_at": "1710415713",
			"login_with": "appuser",
			"status": "1",
			"billing_address": "",
			"state": "",
			"city": "",
			"curbside_vehicle_type": null,
			"customer_payment_id": "",
			"guest_login": "1",
		}

		localStorage.setItem('user_detail' ,JSON.stringify(data));
		this.router.navigateByUrl('/');
		
	}
	
	forGotPassword(){
		this.forGotPasswordMessageApi='';
		$('#forgotPassword').modal('show');
	}
	forGot(){
		if (!this.forgotForm.value.forgotemail.includes('@')) {
			this.forGotPasswordMessageApi = "Invalid email address";
			return ;
		}
		
		this.isSubmittedForgot = true;
		if(this.forgotForm.invalid){
		  return;
		}
		this.forGotPasswordSpin=1;
		const forGotData = new FormData();
		forGotData.append( 'email', this.forgotForm.value.forgotemail );
		this._http.postRequest('forgot_password.php',forGotData).subscribe((reponse : any)=>{
			this.forGotPasswordSpin=0;
			this.forGotPasswordMessageApi=reponse.message;
			
		}) 
	}

}
